
export default {
    props: {
		productInfo: Array,
		showTooltip: {
			type: Boolean,
			default: true
		},
		activePromo: Object
	},
	data() {
		return {
			infoTooltip: `You get a download of the course for offline access via our desktop & mobile apps plus streaming access to this course forever on any device.`,
			memberTooltip: `Your Price includes available TrueFire Cash and All Access Discount, and Owner Discount, if applicable. Adding multiple items to your cart can affect final calculations.`,
			expDate: ``
		}
	},
	methods: {
		formatDate() {
			const dateArray = this.activePromo.end_date.split('-');
			try {
				this.expDate = dateArray[1] + '/' + dateArray[2] + '/' + dateArray[0];
			} catch(e) {
				console.log('Error formatting expiration date.')
			}
		}
	},
	created() {
		if (this.activePromo && this.activePromo.end_date) this.formatDate()
	}
}
